import { Component, Input } from '@angular/core';

/**
 * The app's one shared "bordered list of things" shell — originally Known Devices' `kd-list`,
 * extracted so every other feature that needs this shape (Webhooks, and Known Devices itself)
 * renders through the same component instead of each hand-copying its markup and CSS.
 */
@Component({
  selector: 'app-item-list',
  templateUrl: './item-list.component.html',
  styleUrl: './item-list.component.scss',
})
export class ItemListComponent {
  @Input() countLabel = '';
  @Input() hintLabel = '';
  @Input() loading = false;
  @Input() empty = false;
  @Input() skeletonRows: number[] = [1, 2, 3, 4];
}
